<template>
  <div class="background" id="background"  ref="scrollContainer" >
    <div style="font-size:0;">-->
      <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2LWWLsTK.jpeg" width="100%" />
    </div>
    <div style="padding:0.5rem 0;">
      <div class="inputForm">

        <div class="content">
          <van-search
              v-model="query.numberKeyword"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
              @cancel="onCancel"
          />
          <div class="keylist">


            <div :class="query.numberKeyword===''?'keyitemA':'keyitem'" @click="searchPhone('')">全部</div>
            <div :class="query.numberKeyword===item?'keyitemA':'keyitem'"  @click="searchPhone(item)" v-for="(item,index) in keyList">{{ item}}</div>

          </div>

          <div class="tel-number-x">
            <div :class="query.phone==item?'tel-number':'tel-numbera'" v-for="(item,index) in phoneNumberList">
              <div class="flex items-center">
                <div v-html="repaceinfo(item)">{{ repaceinfo(item) }}</div>
                <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2MUVjRK7.gif" alt="" class="hot-icon">
              </div>
              <div class="butok" style=" color: rgb(255, 0, 0);"  @click="select(item)"> 立即领取 </div>
            </div>

          </div>
          <div style="margin: 2rem">

            <van-button  icon="replay" color="#b81e20" round type="info"  @click="onSearch" >换一批</van-button>
          </div>

        </div>




      </div>
    </div>


    <div style="font-size:0;">
      <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2L1ToToC.jpg" width="100%" />
    </div>

    <div style="font-size:0; ">
      <div style="font-size: 2rem;padding: 1.5rem;background-color: #501f7a;color: #f5ce55;">关于进一步落实电话用户真实身份信息登记规定的公告</div>
      <div style="font-size: 1.3rem;padding: 1.5rem;text-align: left;background-color: #501f7a;  color: #fff;">
        <br/>尊敬的客户：
        <br/><br/>根据《中华人民共和国反恐怖主义法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电话用户真实身份信息登记规定》（工业和信息化部令第25号）、《工业和信息化部关于贯彻落实<反恐怖主义法>等法律规定进一步做好电话用户真实身份信息登记工作的通知》（工信部网安〔2016〕182号）等国家相关文件规定，为保障国家安全和社会安定、维护人民群众合法权益，加强网络信息保护和用户个人信息安全，即日起依法强化落实电话用户真实身份信息登记工作。现公告如下：
        <br/><br/>1、我司各类营业网点(含自有营业厅、网上营业厅、授权合作代理点等)在为用户办理固定电话、移动电话（含无线上网卡）、有线宽带等入网手续时，须出示本人有效证件原件（二代及以上），政企单位客户统一办理入网手续的，还需同时提供政企单位客户有效证件原件以及单位责任人、经办人、使用人等个人有效证件原件，使用身份证识别设备进行核验并登记，通过系统自动录入用户身份信息，现场拍摄、留存用户现场照片。针对身份证以外的其他有效证件客户，需到我司自有营业厅办理开户入网手续。对于身份不明或拒绝身份查验的，将不提供相应服务。
        <br/><br/>2、在网用户使用的移动电话、固定电话等电信业务尚未登记真实身份信息或身份信息登记不完整、不准确的，政企单位客户尚未完整登记单位信息、责任人身份信息、经办人身份信息、具体电话使用人身份信息的，在规定时间内未完成真实身份信息登记的，我司将根据国家规定限制用户办理业务、依法停止通信服务。请尚未完成实名登记的用户尽快持有效证件原件和本机号卡至我司自有营业厅进行实名补登手续，以免影响正常通信服务。
        <br/><br/>3、自2016年11月1日起，我司对个人用户同一身份证件开户实施一证五号限制，同一用户在用电话卡超过5张的，不得再办理新卡。用户办理过户手续的，须双方本人持有效证件到我司自有营业厅办理相关手续。
        <br/><br/>4、未满8周岁（不含8周岁）的用户不可办理电话用户入网；未满16周岁及其他无民事行为能力的用户，由其法定代理人在自有营业厅代为办理，如实登记用户和法定代理人证件信息，并现场拍摄和留存法定代理人照片。
        <br/><br/>本公告未尽事宜，以国家颁布的法律法规以及工业和信息化部发布的有关文件要求为准。
        <br/><br/>特此公告。
      </div>
      <div style="font-size: 1.3rem;padding: 1.5rem;text-align: right;background-color: #501f7a;  color: #fff;">
        <br/><br/> 中国联合网络通信有限公司嘉兴市分公司 <br/><br/> 2022年10月28日

      </div>
      <div style="font-size: 1.3rem;padding: 1.5rem;text-align: left;background-color: #501f7a;  color: #fff;">
        <br/><br/>
        有效身份证件：
        <br/><br/>*个人用户：
        <br/>①本人居民身份证、临时居民身份证、户口簿、中国人民解放军军人身份证件、中国人民武装警察身份证件、港澳居民来往内地通行证、台湾居民来往大陆通行证、港澳台居民居住证、外国公民护照等；
        <br/>②委托他人办理业务，委托代办人应同时提交委托人和代办人的有效身份证件。
        <br/><br/>*单位用户：
        <br/>①营业执照、加载统一社会信用代码的营业执照、事业单位法人证书或者社会团体法人登记证书、法律、行政法规和国家规定的其他有效证件或者证明文件；
        <br/>②单位办理登记的，除出示以上证件之一外，还应当出示经办人的有效证件和单位的授权书；
        <br/>③单位用户办理的电话用户入网，应同时提供实际使用人的有效身份证件。
      </div>

      <div style="font-size: 1.3rem;padding: 0rem;text-align: left;background-color: #501f7a;  color: #fff;">
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2L7tW4cV.jpg" width="100%" />
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2L1ZiTC7.jpg" width="100%" />

        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2L1TqnZZ.jpg" width="100%" />


      </div>

    </div>


    <van-popup v-model="showArea" position="bottom">
      <van-picker show-toolbar title="地区选择" :columns="areaInfo" @confirm="onAreaConfirm" @cancel="showArea=false"/>
    </van-popup>


    <van-dialog v-model="showProtocol" title="入网协议">
      <div style="height:35rem;margin:1rem;overflow-y:scroll;text-align:left;white-space: pre-wrap;color: #646566;font-size: 1.1rem">
        中国联通客户入网服务协议
        甲方：XXX
        乙方：中国联合网络通信有限公司浙江分公司
        根据《中华人民共和国合同法》、《中华人民共和国电信条例》等有关法律法规的规定，甲乙双方在平等、自愿、公平、诚信的基础上，基于对乙方通信服务的了解和需求，甲方自愿申请成为乙方客户，并达成协议如下：
        第一条 入网要求及业务办理
        （一）甲方办理入网、变更手续时，应提交以下登记资料：
        1、个人客户：提供个人有效身份证件原件，委托他人办理的应同时提交本人及代理人有效身份证件原件及授权委托书。利用个人临时身份证件原件办理的，须同时提供公安部门出具的身份证领取凭证、身份信息辅助证件（驾照、医保卡或户口本等），不得委托他人办理。
        2、单位客户：提供单位有效证件原件（或加盖公章的单位有效证件复印件）、经办人有效身份证件原件、加盖公章的单位介绍信等。
        3、甲方户籍所在地（以有效身份证件的住址为准）或法定住所地（单位有效证件上单位注册地）不在本地的，应该按照乙方的要求办理相应的担保手续。
        （二）甲方应使用国家给予入网许可标志的终端设备，终端设备应具备支持所选服务的相应功能，如无法支持所选服务，甲方应自行承担后果，并向乙方全额支付其所选服务的全部费用。
        （三）甲方欲将业务号码过户时，应先交清所有费用，过户时须由双方持有效身份证件原件办理。如有特殊情况，甲方可委托他人办理，但应同时提交本人及代理人有效身份证件原件及授权委托书。
        （四）在甲方通过过户成为新机主的情形下，如因原机主未亲自到场办理过户而导致原机主就此提出异议，甲方应无条件放弃因过户产生的全部权益，并承担由此对原机主及对乙方造成的一切损失。过户代理人对此承担连带责任。
        （五）甲方采用担保人方式入网的，办理过户业务时，甲方须提交担保人出具的书面文件，说明担保人同意继续担保或要求终止担保。新机主应符合本协议第一条第（一）款的条件。
        （六）甲方本人未到场，由代理人、经办人办理各类业务的，甲方应承担由此产生的责任与义务；代理人、经办人承担连带责任。
        第二条 费用标准和费用交纳
        （一）乙方应在国家电信资费主管部门允许的范围内设定资费标准、向客户明码标价、公告交费期限信息；甲方应在乙方明示的期限内足额交纳各项通信费用。
        （二）甲方使用乙方提供的资费套餐方案，套餐有效期为一年（双方特殊约定的除外）。套餐到期后，双方如无异议，有效期逐年自动顺延。如无特殊约定，甲方在有效期内或到期后可更换套餐。
        （三）如遇国家统一调整通信费用标准，则按国家统一规定执行。如遇乙方发布、调整资费，自乙方公告确定的生效日起执行新的资费标准。在乙方公告确定的生效日前，甲方未提出异议的视为同意，协议继续履行；甲方提出异议且未能与乙方达成一致的，甲方向乙方结清全部未付款项后本协议自动终止。
        （四）若甲方为后付费用户，每月1日至每月最后一天为支付上月费用的交费期限。甲方应按时交纳通信费用。甲方未在约定期限内足额交纳通信费用的，乙方每日加收所欠费用的３‰作为违约金，并有权暂停甲方服务；甲方交清欠费和违约金后，除甲方明确提出不开通或已销号外，乙方应在24小时内恢复甲方服务。对前述情形，乙方将保留追缴欠费、违约金及向征信机构提供用户欠费信息的权利，也可用通知单、委托第三方等形式追缴欠费。
        （五）若甲方为预付费用户，则必须保证账户上有充足的款项。如甲方账户满足消费条件的余额不足，乙方有权限制或停止向甲方提供服务，且乙方可不再另行通知。
        （六）甲方定制第三方增值业务或其它收费业务，乙方可以代第三方向甲方收取信息费、功能费等，甲方使用第三方提供的增值业务或其它收费业务由第三方制定收费标准并公布。
        （七）甲方如需开通国际业务、港澳台业务，应按乙方规定交纳相应费用。
        （八）甲方不应以不知晓终端产生网络流量的原因（例如终端软件自动升级）为由，拒绝支付或要求减免相应费用。
        第三条 客户权益
        （一）网络服务
        1、乙方在现有技术条件下的网络覆盖范围内向甲方提供通信服务。
        2、乙方提供的网络服务应符合国家规定的通信质量标准。
        （二）客户服务
        1、乙方在承诺的网络覆盖范围内按照不低于《电信服务规范》的标准向客户提供服务。
        2、乙方向甲方提供客户服务电话10010、网上营业厅www.10010.com等渠道，以便甲方了解乙方各项服务。乙方还应向甲方免费提供通话所在地（仅限大陆地区，不含港澳台）火警119、匪警110、医疗急救120、交通事故报警122等公益性电信服务。
        3、乙方向甲方提供需要甲方支付月功能费的服务项目时，应征得甲方同意；乙方开通服务项目让甲方进行体验时，不收取体验服务项目月功能费。
        4、对于甲方通信服务开通/关闭申请，乙方应在承诺的时限内操作完成（双方另有约定的除外）。乙方超过时限未及时开通/关闭的，应减免甲方由此产生的通信费用。
        5、乙方依法保证甲方的信息资料安全、通信自由和通信秘密，但以下情形不应视为乙方违反本条约定：（1）因追缴欠费需要，向第三方机构和征信机构提供用户个人相应信息及欠费信息的；（2）为向甲方提供更好的服务，通过短信、彩信、wappush、电话、电子邮件、信函、微博、微信等方式向甲方发送业务服务信息或进行互动沟通的；（3）法律法规另有规定的。
        第四条 风险与责任
        （一）甲方应保证入网、变更登记资料真实有效、准确完整，并有义务配合乙方对登记资料进行查验。甲方登记资料如有变更，应主动办理变更手续。因甲方提供的客户资料不详、不实或变更后未及时通知乙方等原因，使乙方无法向甲方提供服务或甲方无法享受到乙方提供的相关服务，乙方无需向甲方承担任何责任。如乙方发现因甲方登记资料失实或者甲方未配合及时更正，乙方有权暂停、终止甲方服务，且乙方无需向甲方承担任何责任。
        （二）甲方应妥善保管自己的用户号码、通信卡、终端、宽带账号，若发现丢失或被盗用，可及时拨打客户服务电话或到乙方营业网点办理暂时停机或修改账号密码手续；并可向公安机关报案，乙方应配合公安机关调查，但乙方不承担上述情形对甲方所造成的后果；如甲方将名下号码交予他人使用，因此引起的义务与责任仍由甲方承担。
        （三）甲方应妥善管理其服务密码。服务密码是甲方办理业务的重要凭证，甲方入网后应立即修改初始服务密码。凡使用服务密码定制、变更或终止业务的行为均被视为甲方或甲方授权的行为，因此引起的义务与责任均由甲方承担。
        （四）乙方按照现有技术标准为甲方提供通信服务，但乙方无法控制第三方利用各种手段从事违法行为等情况的发生，如因第三方的恶意行为造成甲方的损失，乙方对此将不承担相关责任。
        （五）甲方使用固网及宽带业务时，未经有关部门批准许可，不得自行更改其使用性质，不得开设各类服务站点，不得利用计算机互联网络进行任何经营性服务活动，否则乙方有权停止服务，依法追缴各项费用和违约金，并不承担任何责任。
        （六）若非双方另行约定，乙方提供的宽带接入线路最多限定指定数量终端（以当地规则为准）上网使用，未经乙方书面同意，甲方不得私自组网连接其他终端设备。
        （七）甲方退网时，甲方租赁或乙方免费提供给甲方使用的终端设备，应归还乙方或按照甲乙双方相关约定处理。
        （八）甲方在欠费情况下，乙方有权拒绝为甲方开办其他业务（含移网、固网、宽带等所有业务），直至甲方补交全部欠费及违约金。
        （九）乙方在受理业务（服务）后，将进行线路资源核查，对于不具备开通条件的，在乙方告知甲方后，本协议自动终止，乙方退还甲方已交纳费用，但不承担其他责任。
        （十）在固定电话开通并正常使用前（含新装、移机、改号等），甲方不能将已选中号码通知他人或进行宣传，否则由此所造成的后果及损失，由甲方自行承担。
        （十一）甲方所办理的数据业务下行速率标称值仅为乙方提供的数据业务下行速率最高值，乙方不能保证在任何情况下均能达到标称值，甲方对此表示知悉并认可。
        （十二）按照公平使用原则，乙方将对甲方的移动数据流量进行封顶限制，甲方每月的移动数据流量达到或超出流量封顶额度时，乙方可暂停甲方当月的上网服务，次月自动恢复开通。
        （十三）甲方未付的通信费用达到信用额度时（信用额度是指用户可以用于透支消费的最高通信费用额度），应及时补充交纳通信费用；当甲方未付的通信费用超过信用额度时，乙方有权暂停甲方网络服务（超过信用额度停机不受约定交费期限的限制）。
        （十四）甲方发布违法信息、违反公序良俗内容的信息，或未经接收客户同意大量发布商业广告等其他骚扰信息、拨打骚扰电话等不当行为，以及利用乙方提供的服务从事违法犯罪活动的，乙方有权依据行业主管部门、有关行政、司法机关的指令、客户等第三方举报或投诉，以及乙方制定的为保障公众利益的规范，关闭甲方信息发送功能，或暂停直至终止服务，由此造成的后果由甲方承担。
        （十五）因甲方原因造成的通信卡密码丢失、锁卡或被他人获取造成的损失，乙方不承担责任，甲方不能以此为由拒绝按本协议约定支付通信费用。
        第五条 违约责任
        （一）一方违约给对方造成损失的，应当依法承担赔偿责任，但违约方应承担的赔偿损失的责任范围不包括守约方未实现的预期利润或利益、商业信誉的损失、丢失的数据本身及因数据丢失引起的损失、守约方对第三方的责任及其他间接损失。
        （二）因不可抗力导致本协议部分或全部不能履行的，双方可部分或全部免除责任。
        第六条 协议的变更与解除
        （一）乙方在本协议外以公告、使用手册、资费单页等书面形式公开做出的服务承诺，甲方办理各类业务所签署的表单、业务协议、须知等均自动成为本协议的补充协议；与本协议冲突部分以补充协议为准，补充协议中未约定部分以本协议为准。
        （二）甲方要求终止服务（双方另有约定的除外）申请办理拆机或销户的，如甲方预存费用不足，则应按照乙方要求预存一定数额的通信费，次月按照乙方业务规定和双方约定结清相关费用。
        （三）有下列情形之一的，乙方有权单方解除协议，收回号码或账号并终止服务，并保留追究甲方违约责任的权利：
        1、甲方提供的有效证件（包括代理人/经办人提供的有效身份证件）虚假、不实；
        2、甲方自行安装未取得入网许可或可能影响网络安全或网络服务质量设备的；
        3、甲方以担保等方式取得号码使用权的，如担保人违反保证条款或有确切证据证明担保人无能力履行保证责任的；
        4、甲方未办理相关手续，自行改变电信业务使用性质或私自转让租用权的；
        5、甲方欠费停机后3个月仍未交清通信费用和违约金的;
        6、业务（服务）超过约定有效期的；
        7、该号码被国家司法机关认定用于违法犯罪活动或其它不当用途的；
        8、乙方收到国家行政管理部门通知要求停止甲方服务的；
        9、预付费产品在约定期限内未激活的；
        10、违规外呼、呼叫频次异常的；
        11、法律法规规定的其他情形。
        （四）因技术进步或国家政策等原因导致本协议（部分或全部）无法继续履行的，乙方保留对电信业务（服务）做出调整的权利，调整前乙方应按照有关规定发布公告并提出相应解决方案。甲方可就解决方案与乙方协商，但不得要求乙方继续履行本协议。
        第七条 协议争议
        有关协议争议，双方可沟通协商解决；协商不成的，甲方可向当地通信管理局或消费者协会申请进行调解；任何一方均可向乙方住所地的人民法院起诉。
        第八条 协议生效
        在本协议签约页面点击确认签署本协议前，请确保您已充分阅读并完全同意本协议内容，一旦您点击确认签署本协议，即表明您已充分阅读并完全同意本协议内容，本协议即在您与乙方（中国联合网络通信有限公司浙江分公司）之间产生法律效力。如果您不同意本协议的任意内容，或者无法准确理解乙方（中国联合网络通信有限公司浙江分公司）对条款的解释，请不要进行后续操作。本协议一式两份，甲乙双方各执一份，有效期一年。协议到期后，双方如无异议，有效期以一年为周期自动顺延。

      </div>
    </van-dialog>
    <van-dialog v-model="showPresnal" title="个人信息收集证明">
      <div style="height:35rem;margin:1rem;overflow-y:scroll;text-align:left;white-space: pre-wrap;color: #646566;font-size: 1.1rem">
        关于信息收集使用规则公告

        尊敬的客户：
        《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）和《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等国家法律法规的要求，客户在中国联合网络通信有限公司各类营业网点（含自有营业厅、手机营业厅、网上营业厅、授权合作代理商等）办理固定电话、移动电话（含无线上网卡）入网、过户以及需要出示客户证件的有关业务时，客户应配合出示有效证件原件并进行查验、登记，登记信息包括姓名、证件类型、号码及地址等。同时，为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。客户本人持有效证件可通过自有营业厅查询和/或更正本人信息，或登录手机营业厅查询本人信息。

        如客户拒绝依法提供个人有效证件及真实信息，我公司有权不提供服务或终止服务。

        为向客户提供优质、个性化的服务，包括但不限于提供通信服务、保障通信服务安全、改善服务质量、推介个性化产品等，我公司将遵循合法、正当、必要的原则，按照法律法规规定和/或协议约定使用留存客户个人信息，并妥善保管，严格保密，依法保护客户个人信息，非因下列事由，不对外泄露客户个人信息：

        (a)事先获得客户的明确授权；
        (b)根据有关的法律法规要求；
        (c)按照相关司法机关和/或政府主管部门的要求；
        (d)为维护社会公众的利益所必需且适当；
        (e)为维护我公司或客户的合法权益所必需且适当。

        </p>
      </div>
    </van-dialog>

    <van-action-sheet v-model="showPhone" title="领取号码">
      <div class="content">

        <div class="inputForm">

          <div class="form-tips">根据国家实名制要求,请准确提供身份证信息</div>
          <van-field v-model="query.certificateName" placeholder="请填写姓名" label="姓名" clearable/>
          <van-field v-model="query.certificateNumber" placeholder="请填写身份证号" label="身份证号" clearable/>
          <van-field v-model="query.mobilePhone" placeholder="请填写联系电话" label="联系电话" clearable/>
          <van-field v-model="query.area" label="所在地区" placeholder="请选择省、市、区" clearable @click="showArea=true"/>
          <van-field class="phone" v-model="query.phone" label="立即抢号" placeholder="快挑一个喜欢的号码吧" readonly clearable/>

          <van-field v-model="query.address" label="详细地址" placeholder="街道/镇+村/小区/写字楼+门牌号" clearable/>
          <div style="color: rgb(240, 0, 0); margin: 0.16rem 0px 0.08rem; text-align: center;"> 本人可收货详细地址，精确到门牌号 </div>
          <div style="color: rgb(102, 102, 102); text-align: center;"> *请填写真实身份信息，联系电话错误、收货地址错误或过于简单无法正常发货，收货地址请填写完整。 </div>
          <van-button type="danger" size="large" round @click="submit" class="submit-btn" style="margin-top:0.5rem;">立即领取，包邮到家</van-button>

          <div style="margin: 2rem;">

            <van-row>
              <van-col span="3" align="right"></van-col>
              <van-col span="2" align="right"><van-checkbox v-model="checked" checked-color="#b81e20"></van-checkbox></van-col>
              <van-col span="19" align="left">

                <span>我已阅读并同意</span><span class="underline" style="color: rgb(184, 30, 32);" @click="onshowPresnal" >《个人信息收集证明》</span><span>和</span><span class="underline" style="color: rgb(184, 30, 32);"  @click="openProtocol">《入网协议》</span>。


              </van-col>
            </van-row>




          </div>

        </div>


      </div>
    </van-action-sheet>
    <van-popup v-model="showPhone1" position="bottom">
      <van-picker show-toolbar title="新手机号选择" :columns="phoneNumberList" @confirm="onPhoneConfirm" @cancel="showPhone=false"/>
    </van-popup>
    <van-dialog v-model="showAppList" title="专属流量使用APP清单">
      <div style="height:35rem;margin:1rem;overflow-y:scroll;text-align:left;">
        <p v-html="appList">{{appList}}</p>
      </div>
    </van-dialog>
    <van-button type="danger" size="large" round @click="scrollToTop" class="submit-btn"  style="width: 80%; height: 50px; font-size: 18px; background-color: rgb(250, 157, 10); display: block; position: fixed; left: 10%; bottom: -32px; margin: 20px auto 40px;">
      立即选号申请</van-button>


  </div>
</template>

<script>
import saasAPI from '@/api/saas';
import {query} from "../../../../../task-admin-vue/src/api/sys/dict";

export default {
  data() {
    return {
      isShow:false,
      checked:true,
      linkNum:"hD07woHH",
      query: {
        phone:'',
        orderMobile:'',
        pid: this.$route.query.pid,
      },
      areaTreeList: [],
      showArea: false,
      showProtocol: false,
      phoneList: [],
      phoneNumberList: [],
      showPhone: false,
      protocol: '',
      showAppList: false,
      appList: '',
      areaInfo: [
        {
          "code": 330000,
          "name": "浙江",
          "children": [
            {
              "code": 330100,
              "name": "杭州市",
              "children": [
                {
                  "code": 330102,
                  "name": "上城区"
                },
                {
                  "code": 330105,
                  "name": "拱墅区"
                },
                {
                  "code": 330106,
                  "name": "西湖区"
                },
                {
                  "code": 330108,
                  "name": "滨江区"
                },
                {
                  "code": 330109,
                  "name": "萧山区"
                },
                {
                  "code": 330110,
                  "name": "余杭区"
                },
                {
                  "code": 330122,
                  "name": "桐庐县"
                },
                {
                  "code": 330127,
                  "name": "淳安县"
                },
                {
                  "code": 330182,
                  "name": "建德市"
                },
                {
                  "code": 330183,
                  "name": "富阳区"
                },
                {
                  "code": 330185,
                  "name": "临安区"
                },
                {
                  "code": 330186,
                  "name": "钱塘区"
                },
                {
                  "code": 330111,
                  "name": "临平区"
                }
              ]
            },
            {
              "code": 330200,
              "name": "宁波市",
              "children": [
                {
                  "code": 330203,
                  "name": "海曙区"
                },
                {
                  "code": 330205,
                  "name": "江北区"
                },
                {
                  "code": 330206,
                  "name": "北仑区"
                },
                {
                  "code": 330211,
                  "name": "镇海区"
                },
                {
                  "code": 330212,
                  "name": "鄞州区"
                },
                {
                  "code": 330225,
                  "name": "象山县"
                },
                {
                  "code": 330226,
                  "name": "宁海县"
                },
                {
                  "code": 330281,
                  "name": "余姚市"
                },
                {
                  "code": 330282,
                  "name": "慈溪市"
                },
                {
                  "code": 330283,
                  "name": "奉化市"
                },
                {
                  "code": 330284,
                  "name": "高新区"
                },
                {
                  "code": 330285,
                  "name": "杭州湾"
                }
              ]
            },
            {
              "code": 330300,
              "name": "温州市",
              "children": [
                {
                  "code": 330302,
                  "name": "鹿城区"
                },
                {
                  "code": 330303,
                  "name": "龙湾区"
                },
                {
                  "code": 330304,
                  "name": "瓯海区"
                },
                {
                  "code": 330322,
                  "name": "洞头县"
                },
                {
                  "code": 330324,
                  "name": "永嘉县"
                },
                {
                  "code": 330326,
                  "name": "平阳县"
                },
                {
                  "code": 330327,
                  "name": "苍南县"
                },
                {
                  "code": 330328,
                  "name": "文成县"
                },
                {
                  "code": 330329,
                  "name": "泰顺县"
                },
                {
                  "code": 330381,
                  "name": "瑞安市"
                },
                {
                  "code": 330382,
                  "name": "乐清市"
                },
                {
                  "code": 330383,
                  "name": "龙港市"
                }
              ]
            },
            {
              "code": 330400,
              "name": "嘉兴市",
              "children": [
                {
                  "code": 330402,
                  "name": "南湖区"
                },
                {
                  "code": 330411,
                  "name": "秀洲区"
                },
                {
                  "code": 330421,
                  "name": "嘉善县"
                },
                {
                  "code": 330424,
                  "name": "海盐县"
                },
                {
                  "code": 330481,
                  "name": "海宁市"
                },
                {
                  "code": 330482,
                  "name": "平湖市"
                },
                {
                  "code": 330483,
                  "name": "桐乡市"
                },
                {
                  "code": 330484,
                  "name": "濮院"
                }
              ]
            },
            {
              "code": 330500,
              "name": "湖州市",
              "children": [
                {
                  "code": 330502,
                  "name": "吴兴区"
                },
                {
                  "code": 330503,
                  "name": "南浔区"
                },
                {
                  "code": 330521,
                  "name": "德清县"
                },
                {
                  "code": 330522,
                  "name": "长兴县"
                },
                {
                  "code": 330523,
                  "name": "安吉县"
                },
                {
                  "code": 330524,
                  "name": "织里镇"
                },
                {
                  "code": 330525,
                  "name": "南太湖新区"
                }
              ]
            },
            {
              "code": 330600,
              "name": "绍兴市",
              "children": [
                {
                  "code": 330602,
                  "name": "越城区"
                },
                {
                  "code": 330621,
                  "name": "柯桥区"
                },
                {
                  "code": 330624,
                  "name": "新昌县"
                },
                {
                  "code": 330681,
                  "name": "诸暨市"
                },
                {
                  "code": 330682,
                  "name": "上虞市"
                },
                {
                  "code": 330683,
                  "name": "嵊州市"
                }
              ]
            },
            {
              "code": 330700,
              "name": "金华市",
              "children": [
                {
                  "code": 330702,
                  "name": "婺城区"
                },
                {
                  "code": 330703,
                  "name": "金东区"
                },
                {
                  "code": 330723,
                  "name": "武义县"
                },
                {
                  "code": 330726,
                  "name": "浦江县"
                },
                {
                  "code": 330727,
                  "name": "磐安县"
                },
                {
                  "code": 330781,
                  "name": "兰溪市"
                },
                {
                  "code": 330782,
                  "name": "义乌市"
                },
                {
                  "code": 330783,
                  "name": "东阳市"
                },
                {
                  "code": 330784,
                  "name": "永康市"
                }
              ]
            },
            {
              "code": 330800,
              "name": "衢州市",
              "children": [
                {
                  "code": 330802,
                  "name": "柯城区"
                },
                {
                  "code": 330803,
                  "name": "衢江区"
                },
                {
                  "code": 330822,
                  "name": "常山县"
                },
                {
                  "code": 330824,
                  "name": "开化县"
                },
                {
                  "code": 330825,
                  "name": "龙游县"
                },
                {
                  "code": 330881,
                  "name": "江山市"
                }
              ]
            },
            {
              "code": 330900,
              "name": "舟山市",
              "children": [
                {
                  "code": 330902,
                  "name": "定海区"
                },
                {
                  "code": 330903,
                  "name": "普陀区"
                },
                {
                  "code": 330921,
                  "name": "岱山县"
                },
                {
                  "code": 330922,
                  "name": "嵊泗县"
                },
                {
                  "code": 330923,
                  "name": "新城"
                }
              ]
            },
            {
              "code": 331000,
              "name": "台州市",
              "children": [
                {
                  "code": 331002,
                  "name": "椒江区"
                },
                {
                  "code": 331003,
                  "name": "黄岩区"
                },
                {
                  "code": 331004,
                  "name": "路桥区"
                },
                {
                  "code": 331021,
                  "name": "玉环县"
                },
                {
                  "code": 331022,
                  "name": "三门县"
                },
                {
                  "code": 331023,
                  "name": "天台县"
                },
                {
                  "code": 331024,
                  "name": "仙居县"
                },
                {
                  "code": 331081,
                  "name": "温岭市"
                },
                {
                  "code": 331082,
                  "name": "临海市"
                },
                {
                  "code": 331083,
                  "name": "台州湾新区"
                }
              ]
            },
            {
              "code": 331100,
              "name": "丽水市",
              "children": [
                {
                  "code": 331102,
                  "name": "莲都区"
                },
                {
                  "code": 331121,
                  "name": "青田县"
                },
                {
                  "code": 331122,
                  "name": "缙云县"
                },
                {
                  "code": 331123,
                  "name": "遂昌县"
                },
                {
                  "code": 331124,
                  "name": "松阳县"
                },
                {
                  "code": 331125,
                  "name": "云和县"
                },
                {
                  "code": 331126,
                  "name": "庆元县"
                },
                {
                  "code": 331127,
                  "name": "景宁畲族自治县"
                },
                {
                  "code": 331181,
                  "name": "龙泉市"
                }
              ]
            }
          ]
        },
      ],
      showPhone1:false,
      showPresnal:false,
      callbackExtInfo:'',
      keyList:['58','66','88','99','518','158','168','186','618','567','678','789','521']

    }
  },
  methods: {
    scrollToTop() {

      this.$refs.scrollContainer.scrollTo({ top: 150, behavior: 'smooth' })
    },
    select(val){
      this.query.phone=val;
      this.showPhone = true;
      this.query.orderMobile = val;

      console.log(val);

    },
    repaceinfo(v){
      let res=new RegExp("("+this.query.numberKeyword+")",'g');

      let a=v.replace(res,"<span style='color:red'>"+this.query.numberKeyword+"</span>")
      return a
    },
    onSearch(val) {
      this.openPhonePopup()
    },
    onCancel() {

    },
    onAreaConfirm(value, index) {
      this.showArea = false;
      this.query.area = value.join(" ");
      let province = this.areaInfo[index[0]];
      let city = province.children[index[1]];
      let district = city.children[index[2]];
      this.query.sendProvinceCode = province.code;
      this.query.sendCityCode = city.code;
      this.query.sendDistrictCode = district.code;

      console.log(this.query)
    },
    openPhonePopup() {

      let goodsCode='363212082812';
      this.isShow=true;
      saasAPI.selectNumberLTZJJX("36","363", this.query.numberKeyword,goodsCode).then((result) =>{

        console.log(result)
        if (!result.data || result.data.length < 1) {
          this.$toast("该地区暂无可选号码");
        }
        this.phoneList = result.data;
        let numberList = [];
        this.phoneList.map(e => {
          numberList.push(e.serialNumber);
        });
        this.phoneNumberList = numberList;
        //this.showPhone = true;
        this.isShow=false;
      });
    },
    onPhoneConfirm(value, index) {
      this.showPhone = true;

      console.log(value)
      console.log('---------------index-------')
      this.query.orderMobile = this.phoneList[index].serialNumber;
      console.log('---------------index-------')
      //  this.query.numberCheckCode = this.phoneList[index].checkCode;
    },
    openProtocol() {
      this.showProtocol = true;

    },
    onshowPresnal(){
      this.showPresnal=true;
    },
    submit() {

      if(!this.checked){
        this.$toast("请先同意协议");
        return;
      }
      if (!this.query.pid) {
        this.$toast("链接参数有误");
        return;
      }
      if (!this.query.certificateName || !this.query.certificateNumber
          || !this.query.sendProvinceCode || !this.query.sendCityCode || !this.query.sendDistrictCode
          || !this.query.address || !this.query.mobilePhone) {
        this.$toast("请先填写相关信息");
        return;
      }
      this.query.goodsCode="363212082812";
      this.query.resourceId="3064121473844465";

      this.query.pageUrl=location.href;

      if(this.$route.query.callback_ext_info){
        this.query.callbackExtInfo=this.$route.query.callback_ext_info;
      }

      saasAPI.orderCardLTZJJX8(this.query).then(() => {
        this.query = {};
        this.query.pid = this.$route.query.pid;
        this.$toast("提交成功");
      })
    },
    searchPhone(v){

      console.log(v)
      this.query.numberKeyword=v;
      // this.query.phone=v;
      this.openPhonePopup();
    },
  },
  mounted(){

    this.openPhonePopup();
  },
  created() {

    let areaTree = this.areaInfo;
    if (areaTree) {
      areaTree.map(e => {
        e.text = e.name;

        if (e.children) {
          e.children.map(e2 => {
            e2.text = e2.name;

            if (e2.children) {
              e2.children.map(e3 => {
                e3.text = e3.name;
              })
            }
          })
        }
      });
      console.log(areaTree)
      this.areaInfo = areaTree;
    }


  },
}

</script>

<style lang="scss" scoped>
.background {
  background-size: 100% 100%;
  padding-top: 0rem;
  text-align: center;
  background-color: #cab5f8;
}

.inputForm {
  background-color: white;
  width: 85%;
  margin: 0 auto;
  border-radius: 1rem;
  padding: 0.5rem 1rem;
  text-align: center;

  .van-cell{
    margin-top: 0.5rem;

    /* padding: 0 0.16rem 0 0.32rem; */
    -webkit-box-shadow: inset 0 0 0 1px #b81e20;
    box-shadow: inset 0 0 0 1px #b81e20;
    border-radius: 0.4rem;
    /* font-size: 0.28rem; */
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}
.form-tips {
  color: #999;
  font-size: 1.3rem;
  margin: 0.8rem 0;
  text-align: center;

}
.submit-btn {
  color: #fff;
  background-color: #b81e20;
  animation: focus 1s infinite;
  line-height: 4rem;
  height: 4rem;
  font-size: 2rem;

}

.phone{
  span{
    color: red;
  }
}
.tel-number-x {
  display: flex;
  flex-wrap: wrap;
}
.tel-number {
  width: 40%;
  margin-bottom: 0.5rem;
  font-weight: 700;
  padding-left: 2rem;
  margin-top: 1rem;
  .items-center {
    align-items: center;
  }
  .flex {
    display: flex;
  }
  .hot-icon {
    width: 1.5rem;
    height: 1.3rem;
    margin-left: 0.2rem;
  }
  .butok{
    color: rgb(255, 0, 0);
    text-align: left;
    font-size: 1.2rem;
  }
}
.reload-tel-number-btn {
  background-color: #b81e20;
  color: #fff;
  border-radius: 0.3rem;
  width: 2.4rem;
  height: 0.7rem;
  display: block;
  margin: 0.3rem auto 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@-webkit-keyframes focus {
  0% {
    transform: scale(.9);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(.9);
  }
}
@keyframes focus {
  0% {
    transform: scale(.9);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(.9);
  }
}
.view-router{
  padding-bottom: 0px;
}


.keylist{
  display: grid; /* 定义为网格布局 */
  grid-template-columns: repeat(5, 1fr); /* 指定三列等宽 */
  gap: 10px; /* 间距为20像素 */
}
.keyitem{
  background-color: #fff;
  padding: 5px;
  text-align: center;
  border-radius: 20px;
  border: 1px solid #b81e20;
  color: #b81e20;
}

.keyitemA{
  color: white;
  background: rgb(184, 30, 32);
  border-color: rgb(184, 30, 32);

  padding: 5px;
  text-align: center;
  border-radius: 20px;


}


.van-search__content {

  background-color: null;

}



.tel-numbera {
  width: 40%;
  margin-bottom: 0.5rem;
  font-weight: 700;
  padding-left: 2rem;
  margin-top: 1rem;

  .items-center {
    align-items: center;
  }
  .flex {
    display: flex;
  }
  .hot-icon {
    width: 1.5rem;
    height: 1.3rem;
    margin-left: 0.2rem;
  }
  .butok{
    color: rgb(255, 0, 0);
    text-align: left;
    font-size: 1.2rem;
  }
}



</style>
